import {
  useAppSelector,
  useTriggerProductFilterOptionRecount,
} from "@/lib/redux/hooks";
import { ProductFilter } from "@/lib/redux/productFilters/productFiltersSlice";
import { productFilterSelectors } from "@/lib/redux/store";
import { useCallback, useState } from "react";
import SelectorComponent from "./Selector";
import { Container } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Selector = SelectorComponent as any;

const MainFilters: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState<null | ProductFilter>();
  const triggerRecount = useTriggerProductFilterOptionRecount();

  const filters = useAppSelector((state) =>
    productFilterSelectors
      .selectAll(state)
      .filter((filter) => filter.main === true)
  );

  const handleOpen = useCallback(
    async (filter: ProductFilter) => {
      setActiveFilter(filter);
      triggerRecount(filter);
    },
    [setActiveFilter, triggerRecount]
  );

  const handleClose = useCallback(() => {
    setActiveFilter(null);
  }, [setActiveFilter]);

  return (
    <Container>
      {filters.map((filter) => (
        <Selector
          key={filter.id}
          filter={filter}
          isOpen={filter.id === activeFilter?.id}
          handleOpen={() => handleOpen(filter)}
          handleClose={() => handleClose()}
        />
      ))}
    </Container>
  );
};

export default MainFilters;
